import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { ColorPicker, ColorPickerModule } from 'primeng/colorpicker';

@Component({
  selector: 'zop-colorpicker',
  imports:[
    ColorPickerModule,
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    FormlyModule
  ],
template: `
    <div class="color-picker-wrapper">
      <label class="color-picker-label">{{ to.label }}</label>
      <div class="color-picker-container">
        <p-colorPicker 
          #colorPicker
          [formControl]="formControl"
          [formlyAttributes]="field"
          [disabled]="to['disabled']?true:false"
          [format]="to['format'] || 'hex'"
          [style]="{ width: '100%' }">
        </p-colorPicker>
      </div>
    </div>
  `,
  styles: [`
    .color-picker-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .color-picker-label {
      position: absolute;
      top: -10px;
      left: 12px;
      background: white;
      padding: 0 5px;
      font-size: 12px;
      color: #757575;
    }

    .color-picker-container {
      border: 1px solid #c4c4c4;
      border-radius: 4px;
      padding: 11px;
      display: flex;
      align-items: center;
      transition: border 0.2s ease-in-out;
    }

    .color-picker-container:focus-within {
      border: 2px solid #3f51b5; /* Highlight border when focused */
    }
  `]
})
export class ZopColorPicker extends FieldType<FieldTypeConfig> {
  @ViewChild('colorPicker') colorPicker!: ColorPicker;
}
